<template>
  <Layout>
    <div class="banner-page">
      <img src="/img/banner/kontakkami.png" alt="Image" />
    </div>

    <div class="breadcrumbs">
      <div class="container">
        <ul>
          <li>
            <a href="/">Beranda</a>
          </li>
          <li>
            <span>Hubungi Kami</span>
          </li>
        </ul>
      </div>
    </div>

    <section class="page-section covid-section">
      <div class="container">
        <div class="section-title text-center">Hubungi Kami</div>
        <div class="main-content bg-white pad-36">
          <form @submit.prevent="submit" class="standar-form">
            <div
              class="form-group"
              :class="{ 'form-group--error': $v.name.$error }"
            >
              <label for="name">Nama Lengkap</label>
              <input
                type="text"
                class="form-control"
                placeholder="Tulis Nama Lengkap Anda"
                v-model="name"
              />
              <div
                class="error"
                v-if="$v.name.$dirty && !$v.name.required"
              >
                Nama lengkap harus diisi
              </div>
            </div>

            <div class="spacer"></div>
            <div
              class="form-group"
              :class="{ 'form-group--error': $v.name.$error }"
            >
              <label for="name">Nomor Handphone</label>
              <input
                type="text"
                class="form-control"
                placeholder="Tulis Nomor Handphone Anda"
                v-model="nope"
              />
              <div
                class="error"
                v-if="$v.nope.$dirty && !$v.nope.required"
              >
                Nomor Handphone harus diisi
              </div>
            </div>

            <div class="spacer"></div>

            <div
              class="form-group"
              :class="{ 'form-group--error': $v.email.$error }"
            >
              <label for="email">E-Mail Anda</label>
              <input
                type="text"
                class="form-control"
                placeholder="Tulis Email Anda"
                v-model="email"
              />
              <div
                class="error"
                v-if="$v.email.$dirty && !$v.email.required"
              >
                Email anda harus diisi
              </div>
              <div
                class="error"
                v-if="$v.email.$dirty && !$v.email.email"
              >
                Format email anda salah
              </div>
            </div>

            <div class="spacer"></div>

            <div
              class="form-group"
              :class="{ 'form-group--error': $v.pesan.$error }"
            >
              <label for="email">Pesan</label>
              <textarea
                type="text"
                class="form-control"
                placeholder="Tulis Pesan Anda"
                v-model="pesan"
              ></textarea>
              <div
                class="error"
                v-if="$v.pesan.$dirty && !$v.pesan.required"
              >
                Pesan harus diisi
              </div>
            </div>

            <div class="spacer"></div>

            <div
              class="form-group"
              :class="{ 'form-group--error': $v.pesan.$error }"
            >
              <button
                type="submit"
                class="btn btn-cta btn-full mt-1"
                :disabled="submitStatus"
              >
                {{ submitText }}
              </button>
            </div>
          </form>
        </div>
      </div>
    </section>
  </Layout>
</template>

<script>
import axios from '../utils/apimasjid';
import Layout from '../views/layouts/Index.vue';
import { required, email } from 'vuelidate/lib/validators';

import { mapActions } from 'vuex';

export default {
  components: {
    Layout,
  },
  data() {
    return {
      name: '',
      email: '',
      nope: '',
      pesan: '',
      submitStatus: false,
      submitText: 'Kirim Pesan',
    };
  },
  validations: {
    name: {
      required,
    },
    email: {
      required,
      email,
    },
    nope: {
      required,
    },
    pesan: {
      required,
    },
  },
  methods: {
    ...mapActions('transactions', ['resetForm']),
    async submit() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.submitStatus = 'ERROR';
        this.submitStatus = false;
      } else {
        this.submitText = 'Sedang Diproses...';
        this.submitStatus = true;

        var formData = new FormData();
        formData.append('dorequest[fullname]', this.name);
        formData.append('dorequest[email]', this.email);
        formData.append('dorequest[no_hp]', this.nope);
        formData.append('dorequest[pesan]', this.pesan);

        await axios.post('/default/sendhubungikami', formData);

        this.submitStatus = false;
        this.$swal('Pesan berhasil kami terima');
        this.submitText = 'Kirim Pesan';

        this.name = '';
        this.email = '';
        this.nope = '';
        this.pesan = '';
      }
    },
  },
  mounted() {
    this.resetForm();
  },
};
</script>

<style lang="scss" scoped>
p {
  text-align: justify;
}
ol {
  li {
    margin-bottom: 10px;
  }
}
</style>
